import { useState } from "react";

export const usePushToCmsModal = () => {
  const [selectedProductsToPush, setSelectedProductsToPush] = useState([]);

  const handleProductCheckboxChange = (product, isChecked) => {
    const variants = product.aVariants ? JSON.parse(product.aVariants) : [];
    const childIds = variants.map((v) => v.iVariantId);

    setSelectedProductsToPush((prev) => {
      const exists = prev.find((p) => p.productId === product.iProductId);

      if (isChecked) {
        if (!exists) {
          return [...prev, { productId: product.iProductId, child: childIds }];
        } else {
          return prev.map((p) =>
            p.productId === product.iProductId ? { ...p, child: childIds } : p
          );
        }
      } else {
        return prev.filter((p) => p.productId !== product.iProductId);
      }
    });
  };

  const handleVariantCheckboxChange = (
    variantId,
    parentProductId,
    isChecked
  ) => {
    setSelectedProductsToPush((prev) => {
      const productIndex = prev.findIndex(
        (p) => p.productId === parentProductId
      );

      if (productIndex !== -1) {
        const product = prev[productIndex];
        let newChild;

        if (isChecked) {
          newChild = [...new Set([...product.child, variantId])];
        } else {
          newChild = product.child.filter((id) => id !== variantId);

          // If no variants left after unchecking, remove the whole product
          if (newChild.length === 0) {
            return prev.filter((p) => p.productId !== parentProductId);
          }
        }

        const updatedProduct = { ...product, child: newChild };
        const newProducts = [...prev];
        newProducts[productIndex] = updatedProduct;
        return newProducts;
      } else {
        // If not in list and checkbox is being checked, add new entry
        return isChecked
          ? [...prev, { productId: parentProductId, child: [variantId] }]
          : prev;
      }
    });
  };

  const isProductChecked = (productId) => {
    return selectedProductsToPush.some((p) => p.productId === productId);
  };

  const isVariantChecked = (productId, variantId) => {
    const product = selectedProductsToPush.find(
      (p) => p.productId === productId
    );
    return product ? product.child.includes(variantId) : false;
  };

  return {
    handleProductCheckboxChange,
    handleVariantCheckboxChange,
    isProductChecked,
    isVariantChecked,
    selectedProductsToPush,
  };
};
